import * as React from "react";
import { SvgComponentProps } from "../types/SVGPropType";
const DevSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 25}
    height={props.height ? props.height : 21}
    fill="none"
    {...props}
  >
    <path
      stroke="#F5F6F7"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m2.984 18.858 7.47-7.885a.375.375 0 0 0 0-.516l-7.47-7.885M13.484 19.5h9.857"
    />
  </svg>
);
export default DevSVG;
